module.exports = __webpack_public_path__ + "img/precise.66812fef.jpg";